import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dropdown-wr"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 1,
  class: "list-view-btn-wrapper"
}
const _hoisted_4 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!$setup.loading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["stage-nav-wrapper", { 'not-margin': $setup.props.isMapModalView }]),
        id: "stage-nav-wrapper"
      }, [
        (!$props.isBuilderView)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getAvailableStages, (stage) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: _normalizeClass(["button default primary icon-btn stage", { 'stage-selected': $setup.getStageClass(stage?.stageId?._id) }]),
                  onClick: ($event: any) => ($setup.onStage(stage))
                }, "Stage " + _toDisplayString(stage.stageId.title), 11, _hoisted_2))
              }), 256))
            ]))
          : _createCommentVNode("", true),
        (!$props.isBuilderView)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("p", { class: "zoom-info" }, "Zoom in / out. Click stage to view available lots.", -1)
            ]))]))
          : _createCommentVNode("", true)
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_4))
}